export default __webpack_public_path__ + "static/media/CleanEnergyMasterPlan_Thumbnail.c0d2500a.jpg";